/**
 * Returns given `string` after having removed accents and cedillas from it.
 * @param {String} string
 * @return {String}
 */
export function prepare(string) {
    if (typeof string !== "string") {
        throw new TypeError(`Function prepare() expects parameter 1 to be a string, ${typeof string} given`);
    }

    return string
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
}

/**
 * Builds a RegExp where reserved characters and accented characters in given `string` are escaped.
 * @param {String} string
 * @return {RegExp|null}
 */
export function buildSearchRegExp(string) {
    if (typeof string !== "string") {
        throw new TypeError(`Function buildSearchRegExp() expects parameter 1 to be a string, ${typeof string} given`);
    }

    string = string.trim();

    if (string === "") {
       return null;
    }

    return new RegExp(prepare(string).replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "iu");
}
